import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toApplicationData = (data: unknown): TApplicationWorkflowData => {
    return {
        applicationObjectiveQAMap: get(data, 'applicationObjectiveQAMap'),
        languages: get(data, 'languages'),
        timelineEntries: get(data, 'timelineEntries'),
        workflow: toWorkflowData(data),
        workflowType: 'application',
        user: get(data, '_embedded.user'),
    }
}
